import { useState } from 'react';
import { BellOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import { Button, Popover } from '../../../../components/ui';
import { useDuongDan } from '../../../../hooks/useDuongDan';
import { useT } from '../../../../i18n';
import { useDanhDauDaDoc, useThongBaoNhiemVu } from '../../hooks/useNhiemVu';
import type { ThongBaoNhiemVu } from '../../types-nhiem-vu';
import { TaskNotificationList } from './TaskNotificationList';

const SO_TRONG_CHUONG = 10;
const SO_HIEN_TOI_DA = 99;
export const TRANG_THONG_BAO = '/thong-bao';

export function TaskNotificationBell({ onOpenTask }: { onOpenTask: (item: ThongBaoNhiemVu) => void }) {
  const { t } = useT();
  const duongDan = useDuongDan();
  const [open, setOpen] = useState(false);
  const feed = useThongBaoNhiemVu(SO_TRONG_CHUONG);
  const daDoc = useDanhDauDaDoc();
  const chuaDoc = feed.data?.unread_count ?? 0;

  // Đánh dấu đã đọc khi ĐÓNG chứ không khi mở: còn đang xem thì vẫn thấy dòng nào mới.
  const doiMo = (next: boolean) => {
    setOpen(next);
    if (!next && chuaDoc > 0) daDoc.mutate();
  };

  const content = (
    <div className="w-80 max-w-full">
      <div className="max-h-96 overflow-y-auto">
        <TaskNotificationList
          items={feed.data?.items}
          loading={feed.isLoading}
          error={feed.isError}
          onRetry={() => void feed.refetch()}
          onOpen={(item) => {
            doiMo(false);
            onOpenTask(item);
          }}
        />
      </div>
      <div className="flex justify-end border-t border-default px-3 py-2">
        <Link to={duongDan(TRANG_THONG_BAO)} className="text-xs font-medium text-content-link hover:underline">
          {t('vanBanNhiemVu.thongBao.xemTatCa')}
        </Link>
      </div>
    </div>
  );

  return (
    <Popover
      trigger="click"
      placement="bottomRight"
      open={open}
      onOpenChange={doiMo}
      title={t('vanBanNhiemVu.thongBao.tieuDe')}
      content={content}
    >
      <span className="relative inline-flex">
        <Button variant="outline" icon={<BellOutlined />} aria-label={t('vanBanNhiemVu.thongBao.moChuong', { so: chuaDoc })} />
        {chuaDoc > 0 && (
          <span
            aria-hidden
            className="pointer-events-none absolute -right-1.5 -top-1.5 min-w-4 rounded-full bg-danger-600 px-1 text-center text-2xs font-semibold text-content-inverse"
          >
            {chuaDoc > SO_HIEN_TOI_DA ? `${SO_HIEN_TOI_DA}+` : chuaDoc}
          </span>
        )}
      </span>
    </Popover>
  );
}
